import { render, staticRenderFns } from "./ModalPredict.vue?vue&type=template&id=878cfff6&"
import script from "./ModalPredict.vue?vue&type=script&lang=js&"
export * from "./ModalPredict.vue?vue&type=script&lang=js&"
import style0 from "./ModalPredict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports